export default __webpack_public_path__ + "static/media/test-assets.1cac246b.png";